<button
  *ngIf="isButtonVisible"
  [id]="'btn-vote-now-' + ballot.ballotId"
  class="btn body-default-regular btn-primary"
  (click)="voteNow($event)"
  type="button"
>
  Vote Now
</button>
